import * as FileSystem from "expo-file-system";
import { StorageAccessFramework as SAF } from "expo-file-system";
import * as Sharing from "expo-sharing";
import { Linking, Platform, useColorScheme, StyleSheet } from "react-native";
import * as Print from "expo-print";
import MessDiagramm from "../components/MessDiagramm";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { BASE_URL, lightColorDefs, darkColorDefs, developParams } from "../config";
import axios from "axios";
import qs from "qs";

export const serviceKey = 'f4857f4d-cc37-4ee0-b833-8e31dadb723c';
export const requestKey = '40ffbbd1-61f5-49fb-b20d-ef8f78e7aae8';

export const pageTitle = (text) =>
  Platform.select({ web: `Sencono - ${text}`, default: text });

export const readParam = (param) => {
  var params =
    Platform.OS === "web" ? new URLSearchParams(window.location.search) : null;

    if ((!params || (params.size==0)) && developParams) { 
    params = new URLSearchParams(developParams);
    }

  if (Array.isArray(param)) {
    const obj = {};
    param.forEach((element) => {
      obj[element] = params?.get(element);
    });
    return obj;
  } else if (param) return params?.get(param);
  else if (params) {
    const obj = {};
    params.forEach((value, key) => {
      obj[key] = value;
    });
    return obj;
  }
  return null;
};

export const topLogin = () => {
  const toplog = readParam("toplogin");
  return toplog === "true";
};

export const getSchemeStyle = () => {
  const { displaymode } = readParam(["displaymode"]);

  const scheme = ["dark", "light"].includes(displaymode)
    ? displaymode
    : useColorScheme();

  return scheme === "light"
    ? StyleSheet.create(lightColorDefs)
    : StyleSheet.create(darkColorDefs);
};

export class ChipType {
  static None = 0;
  static D1Mini = 1;
  static NodeMCU = 2;
  static ESP12 = 3;
  static ESP07 = 4;
  static ESP32 = 5;

  static chipName = (typ) => {
    switch (typ) {
      case this.D1Mini:
        return "D1 Mini";
        break;
      case this.NodeMCU:
        return "NodeMCU";
        break;
      case this.ESP12:
        return "ESP-12";
        break;
      case this.ESP07:
        return "ESP-07";
        break;
      case this.ESP32:
        return "ESP-32";
        break;
      }
    return "Unbekannt";
  };
}

export const timeValue = (time, withsecs) => {
  let tm = time ? new Date(time) : new Date();
  const options = withsecs
    ? {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      }
    : {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
      };
  return tm.toLocaleDateString("de-DE", options);
};

export const dateValue = (time, fullmonth = false) => {
  let tm = new Date(time);
  let monthval = fullmonth ? "long" : "2-digit";
  const options = {
    year: "numeric",
    month: monthval,
    day: "2-digit",
  };
  return tm.toLocaleDateString("de-DE", options);
};

export const increase_brightness = (hex, percent) => {
  // strip the leading # if it's there
  hex = hex.replace(/^\s*#|\s*$/g, "");

  // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
  if (hex.length == 3) {
    hex = hex.replace(/(.)/g, "$1$1");
  }

  var r = parseInt(hex.substr(0, 2), 16),
    g = parseInt(hex.substr(2, 2), 16),
    b = parseInt(hex.substr(4, 2), 16);

  return (
    "#" +
    (0 | ((1 << 8) + r + ((256 - r) * percent) / 100))
      .toString(16)
      .substring(1) +
    (0 | ((1 << 8) + g + ((256 - g) * percent) / 100))
      .toString(16)
      .substring(1) +
    (0 | ((1 << 8) + b + ((256 - b) * percent) / 100)).toString(16).substring(1)
  );
};

export const colorLuminance = (hex, lum) => {
  // Validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, "");
  if (hex.length < 6) {
    hex = hex.replace(/(.)/g, '$1$1');
  }
  lum = lum || 0;
  // Convert to decimal and change luminosity
  var rgb = "#",
    c;
  for (var i = 0; i < 3; ++i) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
    rgb += ("00" + c).substr(c.length);
  }
  return rgb;
}

export const generateGUID = (digits) => {
  let str = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVXZ";
  let uuid = [];
  for (let i = 0; i < digits; i++) {
    uuid.push(str[Math.floor(Math.random() * str.length)]);
  }
  return uuid.join("");
};

export class MyAsyncStorage {
  /**
   * @param {String} name The Keyname
   * @param {String} def The Default
   */
  static GetString = async (name, def = "") => {
    let _str = await AsyncStorage.getItem(name);
    return _str ? _str : def;
  };
  /**
   * @param {String} name The Keyname
   * @param {String} value The Value
   */
  static SetString = async (name, value) => {
    return await AsyncStorage.setItem(name, value);
  };

  /**
   * @param {String} name The Keyname
   * @param {Boolean} def The Default
   */
  static GetBool = async (name, def = false) => {
    let _bool = await AsyncStorage.getItem(name);
    return _bool ? _bool === "1" : def;
  };
  /**
   * @param {String} name The Keyname
   * @param {Boolean} value The Value
   */
  static SetBool = async (name, value) => {
    return await AsyncStorage.setItem(name, value ? "1" : "0");
  };

  /**
   * @param {String} name The Keyname
   * @param {Integer} def The Default
   */
  static GetInt = async (name, def = 0) => {
    let _int = await AsyncStorage.getItem(name);
    return _int ? parseInt(_int) : def;
  };
  /**
   * @param {String} name The Keyname
   * @param {Integer} value The Value
   */
  static SetInt = async (name, value) => {
    return await AsyncStorage.setItem(name, value.toString());
  };
  /**
   * @param {String} name The Keyname
   * @returns
   */
  static GetJSON = async (name) => {
    let _json = await AsyncStorage.getItem(name);
    try {
      return _json ? JSON.parse(_json) : [];
    } catch {
      return [];
    }
  };
  /**
   * @param {String} name The Keyname
   * @param {Array} value The Value
   */
  static SetJSON = async (name, value) => {
    return await AsyncStorage.setItem(name, JSON.stringify(value));
  };

  /**
   * @param {String} name The Keyname
   */
  static RemoveItem = async (name) => {
    await AsyncStorage.setItem(name, "");
    return await AsyncStorage.removeItem(name);
  };
}

export class FileLog {
  static load = async () => {
    const loguri = FileSystem.documentDirectory + "log.txt";
    let content = "";
    const dirInfo = await FileSystem.getInfoAsync(loguri);
    if (dirInfo.exists)
      return await FileSystem.readAsStringAsync(loguri, {
        encoding: FileSystem.EncodingType.UTF8,
      });

    return "";
  };
  /**
   *
   * @param {String} logtext
   * @returns
   */
  static save = async (logtext) => {
    const loguri = FileSystem.documentDirectory + "log.txt";

    let content = await this.load();
    if (content.length > 0) content += "\r\n";

    content += `${timeValue(null, true)} -> ${logtext}`;
    await FileSystem.writeAsStringAsync(loguri, content, {
      encoding: FileSystem.EncodingType.UTF8,
    });
    return true;
  };

  static clear = async () => {
    const loguri = FileSystem.documentDirectory + "log.txt";

    return await FileSystem.deleteAsync(loguri, { idempotent: true });
  };
}

export class ConsoleLog {
  static log = async (logtext) => {
    console.log(`${timeValue(null, true)} -> ${logtext}`);
  };
}

export const nl2br = (str, is_xhtml) => {
  // http://kevin.vanzonneveld.net
  // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // +   improved by: Philip Peterson
  // +   improved by: Onno Marsman
  // +   improved by: Atli Þór
  // +   bugfixed by: Onno Marsman
  // +      input by: Brett Zamir (http://brett-zamir.me)
  // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // +   improved by: Brett Zamir (http://brett-zamir.me)
  // +   improved by: Maximusya
  // *     example 1: nl2br('Kevin\nvan\nZonneveld');
  // *     returns 1: 'Kevin<br />\nvan<br />\nZonneveld'
  // *     example 2: nl2br("\nOne\nTwo\n\nThree\n", false);
  // *     returns 2: '<br>\nOne<br>\nTwo<br>\n<br>\nThree<br>\n'
  // *     example 3: nl2br("\nOne\nTwo\n\nThree\n", true);
  // *     returns 3: '<br />\nOne<br />\nTwo<br />\n<br />\nThree<br />\n'
  var breakTag =
    is_xhtml || typeof is_xhtml === "undefined" ? "<br " + "/>" : "<br>"; // Adjust comment to avoid issue on phpjs.org display

  return (str + "").replace(
    /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
    "$1" + breakTag + "$2"
  );
};

const ensureDirExists = async (dir) => {
  const dirInfo = await FileSystem.getInfoAsync(dir);
  if (!dirInfo.exists) {
    console.log("Gif directory doesn't exist, creating...");
    await FileSystem.makeDirectoryAsync(dir, { intermediates: true });
  }
};

const saveFile = async (fileExt, data, mimetype) => {
  const permissions = await SAF.requestDirectoryPermissionsAsync();
  if (!permissions.granted) return;

  const url = permissions.directoryUri;
  const fileUri = await SAF.createFileAsync(url, `export${fileExt}`, mimetype);
  await FileSystem.writeAsStringAsync(fileUri, data, {
    encoding: "utf8",
  });
  return true;
};

const shareFile = async (fileExt, data, mimetype) => {
  const expDir = FileSystem.cacheDirectory;
  const fileUri = expDir + "export" + fileExt;
  await ensureDirExists(expDir);
  await FileSystem.deleteAsync(fileUri, { idempotent: true });
  await FileSystem.writeAsStringAsync(fileUri, data, {
    encoding: "utf8",
  });

  let result = null;
  if (await Sharing.isAvailableAsync()) {
    result = await Sharing.shareAsync(fileUri, {
      UTI: fileExt,
      mimeType: mimetype,
    });
  }
  await FileSystem.deleteAsync(fileUri, { idempotent: true });

  return result !== null;
};

function htmlEntities(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

const getHTMLData = (data) => {
  /*   data.data.id
  data.data.name
  data.data.minvalue
  data.data.maxvalue
  data.data.offline
  data.data.erroralways
  data.data.unit
 */
  const messDia = MessDiagramm({
    size: 600,
    data: data.data.data,
    minArea: data.data.minvalue,
    maxArea: data.data.maxvalue,
    noComponent: true,
  });
  let html = `
  <html>
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no" />
    </head>
    <body style="text-align: left; margin: 0px 50px">
      <h1 style="text-align: center;">Sencono Messdatenprotokoll</h1>
      <table cellpadding="5" cellspacing="0" style="width: 100%; ">
        <tr>
          <td style="font-weight: bold;">Zeitraum:</td>
          <td>${dateValue(data.data.datefrom)} - ${dateValue(
    data.data.dateto
  )}</td>
        </tr>
        <tr>
          <td style="font-weight: bold;">Sensor:</td>
          <td>${data.data.name}</td>
        </tr>
        <tr>
          <td style="font-weight: bold;">Standort:</td>
          <td>${data.branchName}</td>
        </tr>
      </table>
      <br><br>
  
      ${messDia}
      <table cellpadding="5" cellspacing="0" style="width: 100%;" border="0">
        <tr style="background-color: #cccccc; padding:5px;">
          <td style="padding:5px; font-weight: bold;">Zeit</td>
          <td style="text-align: right; font-weight: bold;">Wert</td>
          <td style="text-align: right; font-weight: bold;">Batterie</td>
          <td style="text-align: right; font-weight: bold;">WLAN</td>
          <td style="text-align: right; font-weight: bold;">Bemerkung</td>
        </tr>`;

  data.data.data.map((item) => {
    html += `
        <tr>
          <td>${timeValue(item.time)}</td>
          <td style="text-align: right;">${item.value}${item.unit}</td>		
          <td style="text-align: right;">${item.voltage}V</td>	
          <td style="text-align: right;">${item.rssi}dBm</td>
          <td style="text-align: right;">${htmlEntities(item.remark)}</td>
        </tr>`;
  });

  html += "</table>";

  html += `
  <hr>`;

  html += `
  </body>
  </html>`;

  return html;
};
const createPDF = async (data) => {
  const html = getHTMLData(data);

  const { uri } = await Print.printToFileAsync({ html });

  return uri;
};

const printData = async (data) => {
  const html = getHTMLData(data);
  const printer = await Print.selectPrinterAsync();
  await Print.printAsync({ html, printerUrl: printer?.url });
  return true;
};

const sharePDF = async (fileExt, data, mimetype) => {
  const uri = await createPDF(data);

  const expFilename = FileSystem.cacheDirectory + "export" + fileExt;
  FileSystem.moveAsync({ from: uri, to: expFilename });

  let result = null;
  if (await Sharing.isAvailableAsync()) {
    result = await Sharing.shareAsync(expFilename, {
      UTI: fileExt,
      mimeType: mimetype,
    });
  }
  await FileSystem.deleteAsync(expFilename, { idempotent: true });

  return result !== null;
};

const exportPDF = async (fileExt, data, mimetype) => {
  const permissions = await SAF.requestDirectoryPermissionsAsync();
  if (!permissions.granted) return;

  const uri = await createPDF(data);

  const pdfdata = await FileSystem.readAsStringAsync(uri, {
    encoding: FileSystem.EncodingType.Base64,
  });

  const tourl = permissions.directoryUri;
  const tofile = await SAF.createFileAsync(tourl, `export${fileExt}`, mimetype);
  await FileSystem.writeAsStringAsync(tofile, pdfdata, {
    encoding: FileSystem.EncodingType.Base64,
  });
  await FileSystem.deleteAsync(uri);

  return true;
};

export const exportData = async (typ, data) => {
  if (Platform.OS === "web") {
    let exporttoken = "";
    const url = `${BASE_URL}/getdata`;
    let senddata = {
      action: "getexporttoken",
      typ: typ,
      firmid: data.firmid,
      branchid: data.branchid,
      sensorid: data.sensorid,
      datefrom: data.datefrom,
      dateto: data.dateto,
    };
    let options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + data.usertoken,
      },
      data: qs.stringify(senddata),
      url,
    };
    await axios(options)
      .then((res) => {
        let _tokendata = res.data;
        console.log(_tokendata);
        exporttoken = _tokendata.token;
      })
      .catch((e) => {
        console.log(`GetExportToken error ${e}`);
      });

    if (exporttoken) {
      Linking.openURL(`${BASE_URL}/exportdata/${exporttoken}`);
    }
  } else {
    const expType = await MyAsyncStorage.GetBool("exportType", true);

    switch (typ) {
      case "print":
      case "printer":
        return await printData(data);
        break;
      case "xml":
        var xml2js = require("react-native-xml2js");

        const xmlString = new xml2js.Builder().buildObject({
          sensorexport: data.data,
        });
        if (Platform.OS === "ios" || !expType)
          return await shareFile(".xml", xmlString, "text/xml");
        else return await saveFile(".xml", xmlString, "text/xml");
        break;
      case "csv":
        // construct csvString
        const headerString = "id,time,value,unit,voltage,rssi,remark,error\n";
        const rowString = data.data.data
          .map(
            (d) =>
              `${d.id},"${d.time}",${d.value},"${d.unit}",${d.voltage},${d.rssi},"${d.remark}"\n`
          )
          .join("");
        const csvString = `${headerString}${rowString}`;

        if (Platform.OS === "ios" || !expType)
          return await shareFile(".csv", csvString, "text/csv");
        else return await saveFile(".csv", csvString, "text/csv");

        break;
      case "json":
        const jsonString = JSON.stringify(data.data, null, "  ");
        if (Platform.OS === "ios" || !expType)
          return await shareFile(".json", jsonString, "application/json");
        else return await saveFile(".json", jsonString, "application/json");
        break;
      case "pdf":
        if (Platform.OS === "ios" || !expType)
          return await sharePDF(".pdf", data, "application/json");
        else return await exportPDF(".pdf", data, "application/pdf");
        break;
    }
  }
  return false;
};

export const checkPassword = (pw) => {
  let strongPassword = new RegExp(
    "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})"
  );
  let mediumPassword = new RegExp(
    "((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,}))"
  );
  if (pw.length !== 0) {
    if (strongPassword.test(pw)) return 3;
    else if (mediumPassword.test(pw)) return 2;
    else return 1;
  } else return 0;
};

export class ChangeType {
  static addStandort = 1;
  static delStandort = 2;

  static textStandort = 11;
  static textTelefon = 12;
  static textStrasse = 13;
  static textOrt = 14;
  static textEMail = 15;

  static addMessstelle = 21;
  static delMessstelle = 22; 

  static textMessstelle = 31;
  static textMessstelleMin = 32;
  static textMessstelleMax = 33;

  static addBenutzer = 41;
  static delBenuter = 42; 

  static textBenutzer = 51;
}

export class RequestBranch {
  isnew;
  intid;
  standort;
  telefon;
  strasse;
  ort;
  email;

  messstellen;
}

export class RequestMeasuringPoint {
  isnew;
  intid;
  bezeichnung;
  min;
  max;
}


